// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"122":"6a765682","787":"4d81cd9f"}[chunkId] + ".chunk.js";
};